import React, { type ReactElement } from 'react';

import cn from 'classnames';

import AccessKeyBanner from '@/components/AccessKeyBanner';
import CelebrationBannerV2 from '@/components/Promotion/CelebrationBannerV2';

import styles from './BannersBox.module.scss';

type BannersBoxProps = {
  className?: string;
  isErrorModalAllowed?: boolean;
  placeholder?: React.ReactNode;
  stacked?: boolean;
};

const isEmpty = (content: ReactElement) =>
  React.Children.toArray(content.props.children)
    .map((child) => !child.type(child.props))
    .every((value) => value === true);

const BannersBox = ({ className, placeholder = null, stacked = false }: BannersBoxProps) => {
  const content = (
    <>
      <CelebrationBannerV2 className={styles.item} />
      <AccessKeyBanner className={styles.item} />
    </>
  );

  if (isEmpty(content)) {
    return placeholder;
  }

  return (
    <div className={cn(styles.root, className)} data-stacked={stacked}>
      {content}
    </div>
  );
};

export default BannersBox;
